module.exports = __webpack_public_path__ + "img/arrow-left.4bfaeeb1.svg";